"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
export default class Ports {
  constructor(app) {
    __publicField(this, "app");
    __publicField(this, "subscriptions", []);
    this.app = app;
  }
  safeSubscribe(portName, callback) {
    var _a;
    if (typeof ((_a = this.app.ports) == null ? void 0 : _a[portName]) != "undefined") {
      this.app.ports[portName].subscribe(callback);
      this.subscriptions.push({ portName, callback });
    } else {
      console.info(
        `Elm port '${portName}' doesn't appear to be used and maybe should be deleted?`
      );
    }
  }
  // Elm can't be torn down, so a component that started it drops these on
  // unmount and binds the same callbacks again if it remounts (StrictMode).
  unsubscribeAll() {
    this.subscriptions.forEach(
      ({ portName, callback }) => this.app.ports[portName].unsubscribe(callback)
    );
  }
  resubscribeAll() {
    this.subscriptions.forEach(
      ({ portName, callback }) => this.app.ports[portName].subscribe(callback)
    );
  }
  safeSend(portName, value) {
    if (typeof this.app.ports[portName] != "undefined") {
      this.app.ports[portName].send(value);
    } else {
      console.info(
        `Elm port '${portName}' doesn't appear to be used and maybe should be deleted?`
      );
    }
  }
}
